
    import * as React from 'react';

    const Hide16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M14 7.625H2v.75h12z" /></svg>
        </div>
      );
    };

    Hide16.displayName = 'Hide16';

    export default Hide16;
  